import script from "./agoTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./agoTopic.vue?vue&type=script&setup=true&lang=js"

import "../../styles/removeVantcell.css?vue&type=style&index=0&lang=css"
import "./agoTopic.vue?vue&type=style&index=1&id=dc40df40&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc40df40"]])

export default __exports__